/**
 * First we will load all of this project's JavaScript dependencies which
 * includes Vue and other libraries. It is a great starting point when
 * building robust, powerful web applications using Vue and Laravel.
 */

require('./bootstrap');

import 'vue-select/dist/vue-select.css';


import Vue from 'vue';
import VueRouter from 'vue-router'
import Buefy from 'buefy';
import PortalVue from 'portal-vue';
import router from './router'
import helpers from "./helpers";
import components from "./mixins/components";
import VueCharts from "vue-chartjs";
import vSelect from 'vue-select'



Vue.use(Buefy);
Vue.use(PortalVue);
Vue.use(VueRouter);
Vue.use(VueCharts);

Vue.mixin(helpers)
Vue.prototype.$modelComponents = components;

/**
 * The following block of code may be used to automatically register your
 * Vue components. It will recursively scan this directory for the Vue
 * components and automatically register them with their "basename".
 *
 * Eg. ./components/ExampleComponent.vue -> <example-component></example-component>
 */

const files = require.context('./components', true, /\.vue$/i);
files.keys().map(key => Vue.component(key.split('/').pop().split('.')[0], files(key).default));
Vue.component('v-select', vSelect)
/**
 * Next, we will create a fresh Vue application instance and attach it to
 * the page. Then, you may begin adding components to this application
 * or customize the JavaScript scaffolding to fit your unique needs.
 */

const app = new Vue({
    el: '#app',
    router
});

const formSidebar = document.querySelector('.form-sidebar');
if( formSidebar ) {
    document.querySelector('.toggle-sidebar').addEventListener('click', function() {
        document.querySelector('.resource-form').classList.toggle( 'sidebar-open' )
    })
}

export default app;
